import type { Archetype } from "@/pages/home/types";

/** "Jump to" destinations, per archetype.
 *
 *  The old Home had ONE fixed list — Fresh / Clients / Placements / Deals —
 *  rendered in a 6-column grid, so an executive manager with 25 available
 *  pages saw the same four links as a broker with 8, and the row ended in two
 *  dead columns. Each archetype now names its own most-useful destinations;
 *  the result is still filtered through `allowed_pages`, so a locked page
 *  never appears and a tile can never lead to a 403.
 */
const BY_ARCHETYPE: Record<Archetype, string[]> = {
  apex: ["/team", "/analytics/benchmarks", "/finance", "/audit", "/deals", "/placements"],
  operations: ["/admin/jobs", "/vault", "/team", "/schedule", "/placements", "/deals"],
  manager: ["/team", "/placements", "/deals", "/fresh", "/clients", "/schedule"],
  producer: ["/fresh", "/clients", "/placements", "/deals", "/publish", "/owner-finder"],
  minimal: ["/profile"],
};

export function shortcutsFor(archetype: Archetype, allowed: Set<string>): string[] {
  return (BY_ARCHETYPE[archetype] ?? BY_ARCHETYPE.producer).filter((p) =>
    allowed.has(p),
  );
}
